import apiHttpClient from "libs/api-http-client";
import { FundGvDistribution } from "types/fund-gv-distribution";

export interface GetFundGvDistribution {
  fundAccountId: number;
  distributionId: number;
}
export const getFundGvDistributionAPI = (
  input: GetFundGvDistribution
): Promise<FundGvDistribution> =>
  apiHttpClient.get(`fund-gv-distribution`, {
    params: {
      fundAccountId: input.fundAccountId,
      distributionId: input.distributionId,
    },
  });
